// @ts-ignore
import MarkerShadow from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';
import { MapLayer } from '../../types';
import { useMap } from 'react-leaflet';
const iconOptions = {
    iconAnchor: [15, 38],
    iconSize: [30, 38],
    popupAnchor: [0, -38],
    shadowUrl: MarkerShadow,
    shadowSize: [41, 41],
    shadowAnchor: [13, 41],
};
const activeIconOptions = {
    iconAnchor: [20, 50],
    iconSize: [40, 50],
    shadowSize: [55, 55],
    shadowAnchor: [18, 55],
    popupAnchor: [0, -49],
};
// todo: make getMarkerIcon optional
export const createMarkerIcon = (getMarkerIcon, isActive, data) => new L.Icon({
    ...(isActive ? activeIconOptions : iconOptions),
    iconUrl: getMarkerIcon(isActive, data) || 'some default url',
});
export const createIcon = (iconOptions) => new L.Icon(iconOptions);
export const useLocateUser = () => {
    const map = useMap();
    return map.locate;
};
export const MAP_URL = {
    [MapLayer.openStreetMap]: {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    },
    [MapLayer.googleMaps]: {
        url: 'https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}',
        attribution: '&copy; <a href="https://www.google.com/intl/en-GB_ALL/permissions/geoguidelines/">Google Maps</a> contributors',
    },
    [MapLayer.googleMapsSatellite]: {
        url: 'https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
        attribution: '&copy; <a href="https://www.google.com/intl/en-GB_ALL/permissions/geoguidelines/">Google Maps</a> contributors',
        subdomains: ['mt1', 'mt2', 'mt3'],
    },
};
